export default __webpack_public_path__ + "static/media/sorting_2.ff3bdad1.png";